import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../configureStore';

export const designSyncStatusSelector = ({ entities }: RootState) => {
  return entities.designSyncStatus;
};

export const designSelector = ({ entities }: RootState) => {
  return entities.design;
};

export const getDesignSyncStatus = createSelector(
  designSyncStatusSelector,
  ({ statuses }) => statuses
);


export const getDesignById = createSelector(
  [designSelector, (_, designid) => designid],
  ({ items: designs }, designid) => designs.find((design) => design.designid === designid)
);
